export default __webpack_public_path__ + "static/media/logo.e54ce603.svg";